import { useState, useEffect } from 'react'
import { format, differenceInSeconds, parseISO } from 'date-fns'

// Libs

// Constants
import { ROOM_LIVE_TYPE } from '@/constants/liveRoom'

const useLiveTime = ({
  startTime = '',
  endTime = '',
  liveType = ROOM_LIVE_TYPE.CURRENT,
  isOnlyEndCount = false,
}: {
  startTime: string | number
  endTime?: string
  liveType?: number
  isOnlyEndCount?: boolean
}) => {
  const [liveTime, setLiveTime] = useState('00:00:00')
  const [endCountTime, setEndCountTime] = useState('00:00')

  const targetDate = parseISO(endTime)
  const currentDate = new Date()

  const secondsDifference = differenceInSeconds(targetDate, currentDate)
  const isLessThenTenMinutes = secondsDifference <= 60 * 10 // 10 分鐘
  const isEndTime = secondsDifference <= 0

  useEffect(() => {
    if (isOnlyEndCount) return

    if (liveType === ROOM_LIVE_TYPE.CURRENT && startTime) {
      const timeId = setInterval(() => {
        const start = new Date(startTime)
        const end = new Date()

        const secondsDiff = differenceInSeconds(end, start)
        const date = new Date('1970/01/01 00:00')
        date.setSeconds(secondsDiff)

        setLiveTime(format(date, 'HH:mm:ss'))
      }, 1000)

      return () => clearInterval(timeId)
    }
  }, [startTime, liveType, isOnlyEndCount])

  useEffect(() => {
    if (isOnlyEndCount) return

    if (liveType === ROOM_LIVE_TYPE.PAST && endTime) {
      const start = new Date(startTime)
      const end = new Date(endTime)

      const secondsDiff = differenceInSeconds(end, start) || 0
      const date = new Date('1970/01/01 00:00')
      date.setSeconds(secondsDiff)

      setLiveTime(format(date, 'HH:mm:ss'))
    }
  }, [startTime, liveType, endTime, isOnlyEndCount])

  useEffect(() => {
    if (isEndTime) return

    const timer = setInterval(() => {
      const start = new Date()
      const end = new Date(endTime)

      const secondsDiff = differenceInSeconds(end, start) || 0

      const date = new Date('1970/01/01 00:00')
      date.setSeconds(secondsDiff)

      // 剩超過一小時要帶 HH，否則 mm:ss 會把小時整個丟掉——剩 2:46:48 會顯示成 46:48，
      // 看起來像只剩 46 分鐘。（直播不會排超過 24 小時，所以不處理天）
      setEndCountTime(format(date, secondsDiff >= 3600 ? 'HH:mm:ss' : 'mm:ss'))
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [endTime, isEndTime])

  return { liveTime, endCountTime, isLessThenTenMinutes }
}

export default useLiveTime
